import { TextField } from "@mui/material";
import { useEffect, useState, type FC } from "react";
import { Select } from "../components/select/Select";
import dayjs from "../dayjs";

interface EditVersionNameProps {
  value: string;
  onChange: (value: string | null) => void;
}

const EditVersionName: FC<EditVersionNameProps> = ({ value, onChange }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <TextField
      label="Wersja kalkulacji"
      fullWidth
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => onChange(localValue)}
    />
  );
};

interface Props {
  readonly selectedIdx: number;
  readonly numberOfSavedVersions: number;
  readonly draftVersionName?: string;
  readonly versions: {
    readonly versionName?: string;
    readonly metadata?: { readonly createdAt: string; readonly createdBy?: string };
  }[];
  onVersionChange: (idx: number) => void;
  onVersionNameChange: (newName: string | null) => void;
}

const CalculationVersion: FC<Props> = ({
  selectedIdx,
  numberOfSavedVersions,
  versions,
  onVersionChange,
  onVersionNameChange,
  draftVersionName,
}) => {
  const defaultVersionName = (idx: number) => `Wersja ${idx + 1}`;
  if (selectedIdx === numberOfSavedVersions) {
    const versionName = draftVersionName ?? versions[selectedIdx]?.versionName ?? defaultVersionName(selectedIdx);
    return <EditVersionName value={versionName} onChange={onVersionNameChange} />;
  }
  const versionMetadata = versions[selectedIdx]?.metadata;
  const versionDetails = versionMetadata
    ? `Utworzono ${dayjs(versionMetadata.createdAt).format("DD.MM.YYYY")}${versionMetadata.createdBy ? ` przez ${versionMetadata.createdBy}` : ""}`
    : undefined;
  return (
    <Select
      label="Wersja kalkulacji"
      helperText={versionDetails}
      fullWidth
      value={`${selectedIdx}`}
      values={versions.map((v, idx) => ({
        value: `${idx}`,
        label: v.versionName ?? defaultVersionName(idx),
      }))}
      onSelect={(v) => onVersionChange(Number.parseInt(v))}
    />
  );
};

export default CalculationVersion;
